module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "stdapplinf-detail",
      "id": "stdapplinf-detail"
    }
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "700",
      "margin-bottom": "3px"
    }
  }, [_vm._v(_vm._s(_vm.labels['HRRC21P1']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "detail-text",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v(_vm._s(_vm.data.tapplinf.numappl))]), _vm._v(" "), _c('div', {
    staticClass: "detail-text",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.data.tapplinf.desc_numappl))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "stdapplinf-detail-accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P1']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg1', {
    attrs: {
      "labels": _vm.labels['HRRC21P1'],
      "data": _vm.data.tapplinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P2']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg2', {
    attrs: {
      "labels": _vm.labels['HRRC21P2'],
      "data": _vm.data.tapplinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg3', {
    attrs: {
      "labels": _vm.labels['HRRC21P3'],
      "data": _vm.dataPg3,
      "columns": _vm.columns.pg3
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg20"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P20']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg20"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg20', {
    attrs: {
      "labels": _vm.labels['HRRC21P20'],
      "data": _vm.data.tapphinv,
      "columns": _vm.columns,
      "dataTappoinf": _vm.dataTappoinf,
      "receivedStdapplinfTappoinf": _vm.receivedStdapplinfTappoinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg4', {
    attrs: {
      "labels": _vm.labels['HRRC21P4'],
      "data": _vm.data.tapplinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg5"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P5']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg5"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg5', {
    attrs: {
      "labels": _vm.labels['HRRC21P5'],
      "data": _vm.data.tapplinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg16"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P16']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg16"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg16', {
    attrs: {
      "labels": _vm.labels['HRRC21P16'],
      "data": _vm.data.tapplinf
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg6"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P6']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg6"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg6', {
    attrs: {
      "labels": _vm.labels['HRRC21P6'],
      "data": _vm.data.tapplfm
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg7"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P7']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg7"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg7', {
    attrs: {
      "labels": _vm.labels['HRRC21P7'],
      "data": _vm.data.teducatn,
      "columns": _vm.columns.pg7
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg8"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P8']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg8"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg8', {
    attrs: {
      "labels": _vm.labels['HRRC21P8'],
      "data": _vm.data.tapplch,
      "columns": _vm.columns.pg8
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg9"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P9']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg9"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg9', {
    attrs: {
      "labels": _vm.labels['HRRC21P9'],
      "data": _vm.data.tapplwex,
      "columns": _vm.columns.pg9
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg10"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P10']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg10"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg10', {
    attrs: {
      "labels": _vm.labels['HRRC21P10'],
      "data": _vm.data.tapplref
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg12"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P12']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg12"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg12', {
    attrs: {
      "labels": _vm.labels['HRRC21P12'],
      "data": _vm.data.ttrainbf,
      "columns": _vm.columns.pg12
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg13"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P13']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg13"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg13', {
    attrs: {
      "labels": _vm.labels['HRRC21P13'],
      "data": _vm.data.tcmptncy,
      "columns": _vm.columns.pg13
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg14"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P14']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg14"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg14', {
    attrs: {
      "labels": _vm.labels['HRRC21P14'],
      "data": _vm.data.tappldoc,
      "columns": _vm.columns.pg14
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#stdapplinf-detail-accordion",
      "href": "#stdapplinf-detail-pg15"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRRC21P15']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "stdapplinf-detail-pg15"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('stdapplinf-detail-pg15', {
    attrs: {
      "labels": _vm.labels['HRRC21P15'],
      "data": _vm.data.tapploth
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e744359!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdapplinf/stdapplinfDetail.vue
// module id = 3707
// module chunks = 1